import * as React from "react";
import {FC, InputHTMLAttributes} from "react";
import {useAppSelector} from "../../../../store/hook";
import {IFormFieldProps} from "../../IFormFieldProps";
import Element from "../../../../domain/Element/Element";
import RangeSlider from "../range-slider/RangeSlider";
import MagicCheckbox from "../checkbox/MagicCheckbox";
import parse from "html-react-parser";

interface IProps extends InputHTMLAttributes<HTMLInputElement>, IFormFieldProps {
    element: Element
    formData: Record<string, unknown> | []
    register: (() => void) | undefined,
    readOnly?: boolean
}

const PercentageInputRange: FC<IProps> = (
    {
        element,
        formData,
        register,
        error,
        readOnly
    }
) => {

    const elementsFromStoreString = useAppSelector(state => state.elements)
    const elementsFromStore = JSON.parse(elementsFromStoreString.currentElements)

    const attributes = element?.attributes

    const elementDefaultValue = (element) => (
        Number(
            (formData && formData[element.id])
                ? formData[element.id]
                : attributes?.defaultValue
        )
    )

    const elementStartValue = (element) => (
        elementDefaultValue(element)
            ? elementDefaultValue(element)
            : element.attributes?.start
    )

    const decisionElement: Element | undefined = elementsFromStore.find(
        (storedElement) => storedElement.id === element?.attributes?.childElementId
    )

    const isDefaultValueBoolean = (decisionElement?.attributes?.defaultValue === 'true')

    return (
        <>
            <div className={element.cssClasses + ` form-floating`}>
                <div className={`percentage-range`} title={attributes?.help}>
                    <div className={`percentage-range-label`}>
                        <label>{parse(attributes?.label ?? '')}</label>
                    </div>
                    <div className={`percentage-range-content u-pb0`}>
                        <div className={`row middle-md`}>
                            {
                                decisionElement &&
                                <MagicCheckbox
                                    name={decisionElement.name}
                                    id={decisionElement.id}
                                    register={register}
                                    classes={decisionElement.cssClasses}
                                    bold={decisionElement.attributes?.bold}
                                    error={error}
                                    label={decisionElement.attributes?.label}
                                    checked={(formData && typeof formData[decisionElement.id] !== 'undefined') ? ('true' === formData[decisionElement.id] || ('boolean' === typeof formData[decisionElement.id] && formData[decisionElement.id])) : isDefaultValueBoolean}
                                    help={decisionElement.attributes?.help}
                                    readOnly={readOnly || decisionElement.attributes?.readonly}
                                />
                            }
                            <RangeSlider
                                id={element.id}
                                name={element.name}
                                classes={`col-md`}
                                help={element.attributes?.help}
                                min={element.attributes?.min}
                                max={element.attributes?.max}
                                start={elementStartValue(element)}
                                suffix={"%"}
                                error={error}
                                register={register}
                                initialValue={elementDefaultValue(element)}
                                readOnly={readOnly}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PercentageInputRange